import React from "react";
import Icon from "./Icon";
import Link from "./Link";

type Props = {
  links: Array<{ to: string; text: string }>;
};

export default function Breadcrumb({ links }: Props) {
  return (
    <nav>
      <ol className="nav-list no-scrollbar flex flex-row items-center gap-2 overflow-auto">
        {links.map((link, i) => {
          const isLast = i === links.length - 1;

          if (isLast) {
            return (
              <span className="whitespace-nowrap" key={link.to}>
                {link.text}
              </span>
            );
          }

          return (
            <React.Fragment key={link.to}>
              <Link key={link.to} to={link.to} children={link.text} />
              <Icon name="chevron-right" className="text-sm" />
            </React.Fragment>
          );
        })}
      </ol>
    </nav>
  );
}
